var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C7.01664 4 5.5666 4.43987 4.33323 5.26398C3.09986 6.08809 2.13856 7.25943 1.57091 8.62987C1.00325 10.0003 0.854725 11.5083 1.14411 12.9632C1.4335 14.418 2.14781 15.7544 3.1967 16.8033C4.2456 17.8522 5.58197 18.5665 7.03683 18.8559C8.49168 19.1453 9.99968 18.9968 11.3701 18.4291C12.7406 17.8614 13.9119 16.9001 14.736 15.6668C15.5601 14.4334 16 12.9834 16 11.5H8.5V4Z",
    stroke: "#807CE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.5H19C19 6.51088 18.2098 4.60322 16.8033 3.1967C15.3968 1.79018 13.4891 1 11.5 1V8.5Z",
    stroke: "#807CE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e7abd6af22e56b9fbcdd089a8c0bf7f3.svg";
export { ForwardRef as ReactComponent };